export const css = {
	oneaction: 'OnHAJTBO',
	' _key': 'ascm-theme/ascm/quiz-widgets/singlestep'
};

export default css;
